import React, { useMemo, useEffect, useState } from "react";
import Icon from "../components/Icon";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";

import { getAllSchemes, getSchemesById } from "../actions/scheme-action-types";
import {
  getAllStates,
  getAllDealers,
  getAllDistricts,
  getAllTehsils,
} from "../actions/dealer-action-types";
import DistributionSelect from "../components/DistributionSelect";
import SelectCross from "../components/SelectCross";
import { Circle } from "../components/Overlay";
import ConfigData from "../config/config-json.json";

const textStyle = {
  color: "#060808",
  fontSize: "18px",
  fontFamily: "Roboto-Bold",
};

const loaderCss = {
  position: "absolute",
  width: "100%",
  height: "100%",
  justifyContent: "center",
  alignContent: "center",
  backgroundColor: "rgb(0,0,0,0.3)",
  alignItems: "center",
  zIndex: 99999,
};

const viewContainer = {
  marginTop: "18px",
  display: "flex",
  flexDirection: "row",
};

const backContainer = {
  backgroundColor: "#003E85",
  display: "flex",
  width: "40px",
  height: "40px",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
};

const promotionText = {
  color: "#003E85",
  fontSize: "24px",
  fontFamily: "Roboto-Bold",
  marginTop: "25px",
};

const { languageOptions, applicationNames } = ConfigData;

const SelectView = ({ heading, value, style = {} }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflow: "clip",
        backgroundColor: "#F5F5F5",
        paddingTop: 5,
        paddingBottom: 9,
        paddingRight: 16,
        paddingLeft: 16,
        ...style,
      }}
    >
      <text
        style={{
          color: "#515353",
          fontFamily: "Roboto-Regular",
          fontSize: "12px",
        }}
      >
        {heading}
      </text>
      <text
        style={{
          color: "#060808",
          fontFamily: "Roboto-Regular",
          fontSize: "16px",
          wordWrap: "break-word",
          marginTop: "-5px",
        }}
      >
        {value}
      </text>
    </div>
  );
};

const MultiSelectView = ({ label, list, style = {} }) => {
  return (
    <div style={{ flex: 1, ...style }}>
      <div style={{ backgroundColor: "#F5F5F5" }}>
        <text
          style={{
            color: "#515353",
            fontSize: "12px",
            fontFamily: "Roboto-Regular",
            padding: "16px 16px 16px 16px",
            display: "flex",
          }}
        >
          {label}
        </text>
      </div>
      <div style={{ marginTop: 20 }}>
        {list?.map((val) => (
          <SelectCross title={val ?? ""} />
        ))}
      </div>
    </div>
  );
};
const distributionTypeWrapper = {
  display: "flex",
  flexDirection: "row",
  marginTop: "10px",
  marginBottom: "15px",
};

const ViewScheme = ({
  match,
  allSchemes,
  allStates,
  allDealers,
  getAllStates,
  getAllDealers,
  getAllDistricts,
  getAllTehsils,
  allTehsils,
  allDistricts,
  schemeById,
  getSchemesById,
  visible,
}) => {
  useEffect(() => {
    // getAllSchemes();
    getAllStates();
    getAllDealers();
    getAllDistricts();
    getAllTehsils();
  }, []);

  const [distributionType, setDistributionType] = useState("area");
  const [appId, setAppId] = useState({});
  const [language, setLanguage] = useState("");

  let history = useHistory();
  const { schemeId } = match.params;

  useEffect(() => {
    getSchemesById(schemeId);
  }, [schemeId]);

  const scheme = schemeById;

  useEffect(() => {
    const appId = applicationNames.find((val) => val.value === scheme?.appId);
    const lang = languageOptions.find((val) => val.value === scheme?.language);
    setDistributionType(scheme?.distributionType);
    setLanguage(lang?.label);
    setAppId(appId);
  }, [scheme]);

  const getStates = (stateId) => {
    const state = allStates.find((val) => {
      return val.State_Id === stateId;
    });
    return " " + state?.State_Name ?? "";
  };

  const getDistrict = (district_id) => {
    const district = allDistricts.find((val) => {
      return val.District_Id === district_id;
    });
    return " " + district?.District_Name ?? "";
  };

  const getTehsil = (tehsil_id) => {
    const tehsil = allTehsils.find((val) => {
      return val.tehsil_id === tehsil_id;
    });
    return " " + tehsil?.Tehsil_Name ?? "";
  };

  const getDealer = (dealer_code) => {
    const dealer = allDealers?.find?.((val) => {
      return val.dealerCode === dealer_code;
    });
    return " " + dealer?.dealerName ?? "";
  };

  const getDealerERP = (dealer_code) => {
    const dealer = allDealers?.find?.((val) => {
      return val.dealerCode === dealer_code;
    });
    return " " + dealer?.erpcbucode ?? "";
  };

  const distribution = useMemo(() => {
    const districts = [];
    const states = [];
    const dealers = [];
    const dealerERP = [];
    const tehsils = [];
    scheme?.distributions?.map((val) => {
      const state = getStates(val?.stateId ?? "");
      const district = getDistrict(val?.districtId ?? "");
      const dealer = getDealer(val?.dealerCode ?? "");
      const erpCode = getDealerERP(val?.dealerCode ?? "");
      const tehsil = getTehsil(val?.tehsilId ?? "");
      districts.push(district);
      states.push(state);
      dealers.push(dealer);
      dealerERP.push(erpCode);
      tehsils.push(tehsil);
    });
    return {
      states: [...new Set(states)],
      districts: [...new Set(districts)],
      dealers: [...new Set(dealers)],
      dealerERP: [...new Set(dealerERP)],
      tehsils: [...new Set(tehsils)],
    };
  }, [scheme, allStates, allDealers, allTehsils, allDistricts]);

  return (
    <>
      {visible && (
        <div style={loaderCss}>
          <Circle size="Large" top={"30%"} />
        </div>
      )}
      <div
        style={{
          marginTop: "35px",
          marginLeft: "96px",
          marginRight: "96px",
          marginBottom: "60px",
        }}
      >
        <div style={backContainer} onClick={() => history.goBack()}>
          <Icon icon="backIcon" />
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <text style={promotionText}>DOCUMENTS</text>
          <div style={{ marginTop: "20px" }}>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flex: 1,
                  marginRight: 30,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#F5F5F5",
                    flex: 1,
                    paddingTop: 5,
                    paddingBottom: 9,
                    paddingRight: 16,
                    paddingLeft: 16,
                    marginRight: 30,
                  }}
                >
                  <text
                    style={{
                      fontFamily: "Roboto-Regular",
                      color: "#515353",
                      fontSize: "12px",
                    }}
                  >
                    Application Name
                  </text>
                  <text
                    style={{
                      color: "#060808",
                      fontFamily: "Roboto-Regular",
                      fontSize: "16px",
                      marginTop: "-5px",
                    }}
                  >
                    {appId?.label || "-"}
                  </text>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#F5F5F5",
                    flex: 1,
                    paddingTop: 5,
                    paddingBottom: 9,
                    paddingRight: 16,
                    paddingLeft: 16,
                  }}
                >
                  <text
                    style={{
                      fontFamily: "Roboto-Regular",
                      color: "#515353",
                      fontSize: "12px",
                    }}
                  >
                    Document Type
                  </text>
                  <text
                    style={{
                      color: "#060808",
                      fontFamily: "Roboto-Regular",
                      fontSize: "16px",
                      marginTop: "-5px",
                    }}
                  >
                    {scheme?.docType || "-"}
                  </text>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "#F5F5F5",
                  flex: 1,
                  paddingTop: 5,
                  paddingBottom: 9,
                  paddingRight: 16,
                  paddingLeft: 16,
                  maxWidth: "47%",
                }}
              >
                <text
                  style={{
                    fontFamily: "Roboto-Regular",
                    color: "#515353",
                    fontSize: "12px",
                  }}
                >
                  Browse
                </text>
                <text
                  style={{
                    color: "#060808",
                    fontFamily: "Roboto-Regular",
                    fontSize: "16px",
                    marginTop: "-5px",
                    overflow: "hidden",
                  }}
                >
                  {scheme?.docUrl ?? ""}
                </text>
              </div>
            </div>
            <div style={viewContainer}>
              <SelectView
                heading={"Language"}
                value={language || "-"}
                style={{ marginRight: 30 }}
              />
              <SelectView
                heading={"Model"}
                value={scheme?.modelNo || "-"}
                style={{ marginRight: 30 }}
              />
              <div style={{ flex: 1, marginRight: 30 }}>
                <SelectView
                  heading={"Security Type"}
                  value={scheme?.security || "-"}
                  // style={{ marginRight: 30 }}
                />
                {/* <text className={"info-title"}>Downloadable</text>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="radio"
                  checked={scheme?.downloadable}
                  value="yes"
                  name="downloadable"
                />
                <text
                  style={{
                    color: "#060808",
                    fontFamily: "Roboto-Bold",
                    fontSize: "12px",
                    marginLeft: 10,
                    marginRight: 20,
                  }}
                >
                  Yes
                </text>
                <input
                  type="radio"
                  checked={!scheme?.downloadable}
                  value="no"
                  name="downloadable"
                />
                <text
                  style={{
                    color: "#060808",
                    fontFamily: "Roboto-Bold",
                    fontSize: "12px",
                    marginLeft: 10,
                  }}
                >
                  No
                </text>
              </div> */}
              </div>
              <div style={{ flex: 1, marginLeft: 30 }}>
                {/* <text className={"info-title"}>Shareable</text>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="radio"
                  value={true}
                  checked={scheme?.shareable}
                  name="shareable"
                />
                <text
                  style={{
                    color: "#060808",
                    fontFamily: "Roboto-Bold",
                    fontSize: "12px",
                    marginLeft: 10,
                    marginRight: 20,
                  }}
                >
                  Yes
                </text>
                <input
                  type="radio"
                  value={false}
                  checked={!scheme?.shareable}
                  name="shareable"
                />
                <text
                  style={{
                    color: "#060808",
                    fontFamily: "Roboto-Bold",
                    fontSize: "12px",
                    marginLeft: 10,
                  }}
                >
                  No
                </text>
              </div> */}
              </div>
            </div>
            <div style={viewContainer}>
              <SelectView
                heading={"Document Name"}
                value={scheme?.docName || "-"}
              />
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "row",
                  marginLeft: "30px",
                }}
              >
                <SelectView
                  heading={"Start Date"}
                  value={
                    scheme?.startDate
                      ? moment(scheme?.startDate).format("DD-MMM-YY")
                      : "-"
                  }
                />
                <SelectView
                  heading={"End Date"}
                  value={
                    scheme?.endDate
                      ? moment(scheme?.endDate).format("DD-MMM-YY")
                      : "-"
                  }
                  style={{ marginLeft: 30 }}
                />
              </div>
            </div>
            <div style={viewContainer}>
              <SelectView
                heading={"Description"}
                value={scheme?.description || "-"}
              />
              <div style={{ flex: 1, marginLeft: 30 }} />
            </div>
          </div>
          <div style={{ marginTop: "40px" }}>
            <text style={textStyle}>DISTRIBUTION</text>
            <div style={distributionTypeWrapper}>
              <DistributionSelect
                distributionType={distributionType}
                label={"By Geography"}
                type={"area"}
              />
              <div style={{ marginLeft: 20 }}>
                <DistributionSelect
                  distributionType={distributionType}
                  label={"By Dealer"}
                  type={"dealer"}
                />
              </div>
            </div>
            <div>
              {distributionType === "area" && (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <MultiSelectView
                    label="State"
                    style={{ marginRight: 30 }}
                    list={distribution?.states ?? []}
                  />
                  <MultiSelectView
                    label="District"
                    style={{ marginRight: 30 }}
                    list={distribution?.districts ?? []}
                  />
                  <MultiSelectView
                    label="Tehsil"
                    style={{ marginRight: 30 }}
                    list={distribution?.tehsils ?? []}
                  />
                  <div style={{ flex: 1 }} />
                </div>
              )}
              {distributionType === "dealer" && (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <MultiSelectView
                    label="Dealer ERP"
                    style={{ marginRight: 30 }}
                    list={distribution?.dealerERP ?? []}
                  />
                  <MultiSelectView
                    label="Dealership"
                    style={{ marginRight: 30 }}
                    list={distribution?.dealers ?? []}
                  />
                  <div style={{ flex: 2 }} />
                </div>
              )}
              {/* <SelectView
              heading={"State"}
              value={distribution?.states?.toString()}
            />
            <SelectView
              heading={"District"}
              value={distribution?.districts?.toString()}
            />
            <SelectView heading={"Tehsil"} value={""} />
            <SelectView
              heading={"Dealership"}
              value={distribution?.dealers?.toString()}
            /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({
  app: { visible },
  schemes: { allSchemes, schemeById },
  dealers: { allStates, allDealers, allDistricts, allTehsils },
}) => ({
  allSchemes,
  allStates,
  allDealers,
  allDistricts,
  allTehsils,
  schemeById,
  visible,
});

export default connect(mapStateToProps, {
  getAllSchemes: getAllSchemes,
  getAllDealers: getAllDealers,
  getAllStates: getAllStates,
  getAllDistricts: getAllDistricts,
  getAllTehsils: getAllTehsils,
  getSchemesById: getSchemesById,
})(ViewScheme);
